module.exports = require("typedjson");